import { SearchQuery } from "../../documentSet/interfaces/api";
import { get } from "./object";
import { User } from "../../user";

export const buildSearchQuery = (
  query: SearchQuery,
  searchValue: string,
  state: User | null,
  language: string,
  inputIds?: Array<string>,
  attributeFilter?: string,
  values?: Array<string>,
): string => {
  const { params } = query;

  let searchQuery = params
    .map((param) => {
      if (param.name.toLowerCase() === "__query__") {
        return `&query=${encodeURIComponent(searchValue)}`;
      }

      if (param.location && param.isMultiple) {
        const list = get(state, param.location, "");
        return `&${param.name}=${list.map(encodeURIComponent).join(",")}`;
      }

      if (param.location) {
        return `&${param.name}=${encodeURIComponent(
          get(state, param.location, "") as string,
        )}`;
      }

      return `&${param.name}=${encodeURIComponent(param.value)}`;
    })
    .join("");

  if (inputIds) {
    for (const id of inputIds) {
      searchQuery += `&input_ids=${id}`;
    }
  }

  if (attributeFilter) {
    searchQuery += `&attribute_filter=${encodeURIComponent(attributeFilter)}`;
  }

  if (values?.length) {
    searchQuery += `&values=${values.map(encodeURIComponent).join(",")}`;
  }

  searchQuery += `&language=${language}`;

  // Remove the leading & from the search query
  return searchQuery.substring(1);
};
